import { ICommonBotState } from "./CommonBotModule";

export default class CommonBotSelectors {
  public static triggerMessage = (state: ICommonBotState) =>
    state.triggerMessage;

  public static loaded = (state: ICommonBotState) => state.loaded;

  public static placesSearchQuery = (state: ICommonBotState) =>
    state.placesQuery;

  public static placesAutocomplete = (state: ICommonBotState) =>
    state.placesAutocomplete;

  public static selectedCoworkPlace = (state: ICommonBotState) =>
    state.selectedPlace;

  public static connectedWithLinkedin = (state: ICommonBotState) =>
    state.connectedWithLinkedin;
}



// WEBPACK FOOTER //
// ./src/state/modules/commonBot/CommonBotSelectors.ts